import { combineReducers } from 'redux';
import { authStore } from 'src/auth';
import { solutionsStore } from 'src/pages/Solutions';
import { companiesStore } from 'src/pages/Companies';
import { otpStore } from 'src/pages/Otp';
import { usersStore } from 'src/pages/Users';
import { sitesStore } from 'src/pages/Sites';
import { monitoringStore } from 'src/pages/Monitoring';
import { alertsStore } from 'src/pages/Alerts';
import { infraMapStore } from 'src/pages/InfraMap';
import { platformVersionsStore } from 'src/pages/Settings/PlatformVersions';

const rootReducer = combineReducers({
  auth: authStore.reducer,
  solutions: solutionsStore.reducer,
  companies: companiesStore.reducer,
  otp: otpStore.reducer,
  users: usersStore.reducer,
  sites: sitesStore.reducer,
  monitoring: monitoringStore.reducer,
  alerts: alertsStore.reducer,
  infraMap: infraMapStore.reducer,
  platformVersions: platformVersionsStore.reducer,
});

export default rootReducer;
